/* ZED floating Add to cart bar (sections/zed-buy-bar.liquid). New file, not part of Athens.
   A remote control for the page's own product form: it never posts to the cart itself. Its button presses Athens' main
   Add to cart, so the drawer, Dealeasy's quantity cards, Selleasy and Early Bird all behave as they do from the page.
   Show rule (the kit bar's, 76A §6.7): the bar shows while the main Add to cart is outside the band between the header's
   bottom and the bar's top, and hides while it's in that band. Never hidden while it holds focus. */
(function () {
  'use strict';
  if (window.__zbbInit) return;
  window.__zbbInit = true;

  var bar = document.querySelector('.zbb');
  if (!bar) return;
  if (window.Shopify && window.Shopify.designMode) return;
  // A kit page has its own bar.
  if (document.querySelector('.zk-bar')) { bar.remove(); return; }
  // US pause (or any other rule) has hidden it: do nothing, add no page padding.
  if (getComputedStyle(bar).display === 'none') return;

  var D = {};
  try { D = JSON.parse(bar.querySelector('[data-zbb-data]').textContent); } catch (e) { return; }
  var S = D.strings || {};
  var btn = bar.querySelector('[data-zbb-add]');
  var label = bar.querySelector('[data-zbb-label]');
  var sub = bar.querySelector('[data-zbb-sub]');
  var img = bar.querySelector('[data-zbb-img]');
  var who = bar.querySelector('[data-zbb-who]');
  var err = bar.querySelector('[data-zbb-error]');
  var live = bar.querySelector('[data-zbb-live]');
  var BAR_H = 72;

  // The main product form. Athens replaces <product-form> on every variant change, so it's looked up fresh every time.
  function info() { return document.querySelector('.product-info'); }
  function mainForm() {
    var i = info();
    return i ? i.querySelector('product-form') : null;
  }
  function mainBtn() {
    var f = mainForm();
    return f ? f.querySelector('.button-add-to-cart, [type="submit"][name="add"]') : null;
  }
  if (!mainBtn()) { bar.remove(); return; }   // not a standard product page (nothing to drive)

  document.body.classList.add('zbb-page');

  // ---------------------------------------------------------------- what the bar says
  function money(cents) {
    var iso = D.currency || 'AUD';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: iso, currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: whole ? 0 : undefined, maximumFractionDigits: whole ? 0 : undefined }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(whole ? 0 : 2); }
  }
  function currentVariantId() {
    var f = mainForm();
    var input = f && f.querySelector('form [name="id"]');
    return input ? String(input.value) : '';
  }
  // Pages with Dealeasy's quantity cards (Buy 1 / Buy 2+) or any quantity-break app set the price in the cards, so the
  // bar never prints a price there: it can't know which tier the button will add (no price the cart won't charge).
  function hasTierCards() {
    return !!document.querySelector('lb-vd-qty-selector, #lb-vd-cards');
  }
  function mainQty() {
    var f = mainForm();
    var q = f && (f.querySelector('[name="quantity"]') || document.querySelector('.product-info [name="quantity"]'));
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  var lastSig = '';
  function render() {
    var mb = mainBtn();
    var vid = currentVariantId();
    var v = (D.variants || {})[vid] || null;
    var mbSpan = mb && mb.querySelector('span');
    var mbText = mbSpan ? mbSpan.textContent.trim() : (mb ? mb.textContent.trim() : '');
    var disabled = !mb || mb.disabled || mb.hasAttribute('disabled');
    var busy = !!(mb && mb.classList.contains('loading'));
    var text = mbText || (disabled ? S.soldOut : S.addToCart) || 'Add to cart';
    if (!disabled && v && !hasTierCards()) text += ' · ' + money(v.price * mainQty());
    var bits = [];
    if (v && !D.defaultOnly && D.showVariant !== false && v.title) bits.push(v.title);
    if (D.ship) bits.push(D.ship);
    var subText = bits.join(' · ');
    var src = v && v.img ? v.img : null;
    var sig = [text, disabled, busy, subText, src].join('|');
    if (sig === lastSig) return;
    lastSig = sig;
    label.textContent = text;
    btn.disabled = disabled;
    btn.classList.toggle('is-busy', busy);
    if (busy) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
    sub.textContent = subText;
    if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
  }

  // ---------------------------------------------------------------- show / hide
  var state = 'hidden';
  function headerBottom() {
    var h = document.querySelector('sticky-header') || document.getElementById('header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }
  function wanted() {
    var mb = mainBtn();
    if (!mb) return false;
    var r = mb.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return true;   // the main button isn't laid out (hidden): the bar is the way in
    var top = headerBottom();
    var bottom = window.innerHeight - BAR_H;
    var inBand = r.bottom > top && r.top < bottom;
    return !inBand;
  }
  function setState(next) {
    if (next === 'hidden' && bar.contains(document.activeElement)) return;   // never hide with focus inside
    if (next === state) return;
    state = next;
    bar.setAttribute('data-state', next);
    if (next === 'visible') {
      bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden');
      document.documentElement.style.scrollPaddingBottom = BAR_H + 'px';
    } else {
      bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true');
      document.documentElement.style.scrollPaddingBottom = '';
    }
  }
  function dock() {
    var d = document.getElementById('mobile-dock');
    var h = d && d.offsetParent !== null ? d.offsetHeight : 0;
    bar.style.bottom = h ? h + 'px' : '';
  }
  var ticking = false;
  function tick() {
    if (ticking) return;
    ticking = true;
    // A background tab pauses requestAnimationFrame; a timer keeps the bar's state current there too.
    var next = document.hidden ? function (cb) { return setTimeout(cb, 50); } : window.requestAnimationFrame.bind(window);
    next(function () {
      ticking = false;
      render();
      setState(wanted() ? 'visible' : 'hidden');
    });
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', function () { dock(); tick(); });
  bar.addEventListener('focusout', function () { setTimeout(tick, 0); });

  // The drawer: step aside while it's open (body.drawer-open in the CSS is the backstop).
  function aside(on) { bar.classList.toggle('is-aside', !!on); }
  document.addEventListener('cart-drawer:open', function () { aside(true); });
  document.addEventListener('cart-drawer:close', function () { aside(false); tick(); });
  if (typeof window.subscribe === 'function') {
    try {
      window.subscribe('cart-drawer:open', function () { aside(true); });
      window.subscribe('cart-drawer:close', function () { aside(false); tick(); });
    } catch (e) {}
  }

  // Anything in the buy column changing (variant swap, Dealeasy, Early Bird relabel, loading state): redraw.
  var target = info();
  if (target && 'MutationObserver' in window) {
    new MutationObserver(tick).observe(target, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'disabled', 'value', 'hidden'], characterData: true });
  }
  document.addEventListener('product:variant-change', tick);
  document.addEventListener('change', tick, true);
  document.addEventListener('input', tick, true);

  // ---------------------------------------------------------------- the press
  var pressedAt = 0;
  function showError(msg) {
    if (!msg) { err.hidden = true; err.textContent = ''; return; }
    err.textContent = msg;
    err.hidden = false;
    clearTimeout(showError.t);
    showError.t = setTimeout(function () { err.hidden = true; }, 6000);
  }
  btn.addEventListener('click', function () {
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var f = mainForm();
    var mb = mainBtn();
    showError('');
    // No variant chosen yet (the form is hidden until one is): take them to the picker.
    if (!f || !mb || f.classList.contains('visually-hidden')) {
      var p = document.querySelector('.product-info .product-variants, .product-info');
      if (p) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    pressedAt = Date.now();
    mb.click();
    tick();
  });
  who.addEventListener('click', function (e) {
    var p = document.querySelector('.product-info');
    if (!p) return;
    e.preventDefault();
    p.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Results of a press that started on the bar.
  document.addEventListener('cart:item-add', function () {
    if (Date.now() - pressedAt < 15000) { live.textContent = S.added || ''; pressedAt = 0; }
    tick();
  });
  // PUB_SUB_EVENTS is a top-level const in Athens' pubsub.js (not on window); 'cart:error' is its cartError name.
  if (typeof window.subscribe === 'function') {
    try {
      window.subscribe('cart:error', function (data) {
        if (Date.now() - pressedAt > 15000) return;
        pressedAt = 0;
        var m = data && ((typeof data.errors === 'string' ? data.errors : '') || data.message);   // Shopify's description first ("You can't add more ...")
        showError(m || S.fail);
        tick();
      });
    } catch (e) {}
  }

  dock();
  tick();
  window.addEventListener('pageshow', tick);
  window.addEventListener('load', tick);
})();
